export enum INSIGHT_CONSTANTS {
  LOGIN = 'login',
  REGISTER = 'register',
}
